import { FC, useState } from 'react';
import { translate } from '../../i18n';
import { mercadoPagoCardStyles } from './styles';
import { MercadoPagoLogo } from './MercadoPagoLogo';
import { isDesktop } from '../../platform';

export interface MercadoPagoCardProps {
  /** ¿Está seleccionada dentro del carrusel? */
  isSelected?: boolean;
  onPress?: () => void;
  testID?: string;
  accessibilityLabel?: string;
}

/**
 * MercadoPagoCard — opción de pago "Mercado Pago" dentro del carrusel de
 * métodos de pago. Puramente presentacional.
 *
 * Estilos centralizados en styles.ts + i18n para strings.
 */
export const MercadoPagoCard: FC<MercadoPagoCardProps> = ({
  isSelected = false,
  onPress,
  testID = 'mercado-pago-card',
  accessibilityLabel = translate('paymentsUI.mercadopago.ariaLabel'),
}) => {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <button
      onClick={onPress}
      disabled={!onPress}
      data-testid={testID}
      role="button"
      aria-label={accessibilityLabel}
      aria-pressed={isSelected}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{
        ...mercadoPagoCardStyles.button,
        ...(isHovering && !(!onPress) && mercadoPagoCardStyles.buttonHover),
        ...(!onPress && mercadoPagoCardStyles.buttonDisabled),
        ...(isDesktop && mercadoPagoCardStyles.webButton),
        ...(isDesktop && !isSelected && mercadoPagoCardStyles.webButtonCollapsed)
      }}
    >
      <div style={mercadoPagoCardStyles.logoContainer} data-testid={`${testID}-logo-container`}>
        <MercadoPagoLogo />
      </div>
      <p style={mercadoPagoCardStyles.subtitle} data-testid={`${testID}-subtitle`}>
        {translate('paymentsUI.mercadopago.subtitle')}
      </p>
    </button>
  );
};
